import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton
} from '@mui/material'
import { Delete } from '@mui/icons-material'

const LS_DELETE_NOTE = 'dontShowCheckedDeleteNote'

const DeleteNoteDialog = ({ isOpen, handleSubmit, handleClose }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const [skipNextTime, setSkipNextTime] = useState(false)

  return (
    <Dialog className="Profile-gift-analysis-dialog" open={isOpen} onClose={handleClose}>
      <DialogTitle>{t.cards.deleteNote}</DialogTitle>
      <DialogContent>
        <p>{t.cards.deleteNoteConfirm}</p>
        <FormControlLabel
          control={
            <Checkbox checked={skipNextTime} onCheck={() => setSkipNextTime(!skipNextTime)} />
          }
          label={t.cards.noShow}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="text">
          {t.global.cancel}
        </Button>
        <Button
          onClick={async () => {
            handleSubmit(skipNextTime)
            handleClose()
          }}
        >
          {t.cards.delete}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const DeleteNote = ({ deleteNote }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleSubmit = async skipNextTime => {
    if (skipNextTime) localStorage.setItem(LS_DELETE_NOTE, true)
    await deleteNote()
  }

  const handleDeleteNote = () => {
    const skip = localStorage[LS_DELETE_NOTE] === 'true'

    if (skip) {
      setIsOpen(false)
      return handleSubmit(skip)
    }
    setIsOpen(true)
  }

  return (
    <span>
      <IconButton className="Full-card__notes-delete" onClick={handleDeleteNote}>
        <Delete />
      </IconButton>
      <DeleteNoteDialog
        isOpen={isOpen}
        handleSubmit={handleSubmit}
        handleClose={() => setIsOpen(false)}
      />
    </span>
  )
}

export default DeleteNote
